<template>
  <div class="my-page-disbursements__container">
    <ReportsDashboardMetric :value="data.week" format="currency" legend="denne uken" small />
    <ReportsDashboardMetric :value="data.month" format="currency" legend="denne måneden" small />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ReportsDashboardMetric from '@/components/reports/dashboard/ReportsDashboardMetric';

export default {
  name: 'MyPageDisbursements',

  computed: {
    ...mapGetters('reports', {
      data: 'getDashboardCashflowTotals',
    }),
  },

  components: {
    ReportsDashboardMetric,
  },
};
</script>

<style scoped lang="scss">
.my-page-disbursements__container {
  display: flex;
  justify-content: space-around;
}
</style>
